module.exports = __webpack_public_path__ + "img/crashLog.c1f93cda.png";